import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AgronomistRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (user.role !== 'agronomist') {
    return <Navigate to="/" />;
  }

  return children;
};

export default AgronomistRoute;
